class Reveal {
    constructor() {
        this.revealContainers = new Map();

        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.revealElements(entry.target);
                    }
                });
            },
            {
                threshold: 0.2,
                rootMargin: '-50px 0px'
            }
        );
    }

    addContainer(containerClass, childClasses, delay = 200) {
        const containers = document.querySelectorAll(`.${containerClass}`);

        containers.forEach(container => {
            const children = childClasses.map((className, index) => ({
                elements: container.querySelectorAll(`.${className}`),
                delay: delay * index
            }));

            this.revealContainers.set(container, children);
            this.observer.observe(container);

            children.forEach(child => {
                child.elements.forEach(el => {
                    el.style.opacity = '0';
                    el.style.transform = 'translateY(50px)';
                    el.style.transition = 'opacity 0.7s ease-out, transform 0.7s ease-out';
                });
            });
        });
    }

    revealElements(container) {
        const children = this.revealContainers.get(container);

        children.forEach(({elements, delay}) => {
            setTimeout(() => {
                elements.forEach(el => {
                    el.style.opacity = '1';
                    el.style.transform = 'translateY(0)';
                });
            }, delay);
        });

        this.observer.unobserve(container);
    }
} export default Reveal;
